import { render, staticRenderFns } from "./archival.vue?vue&type=template&id=18fe9bf4&"
import script from "./archival.vue?vue&type=script&lang=js&"
export * from "./archival.vue?vue&type=script&lang=js&"
import style0 from "./archival.vue?vue&type=style&index=0&id=18fe9bf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports